
























































































































import { Vue, Component } from 'vue-property-decorator';
import AMSProductCategorySelector from '@/components/AMSProductCategorySelector.vue';
import { AppStore } from '../../store/modules/app';
import Axios from 'axios';
import AMSBreadcrumb from '../../components/AMSBreadcrumb.vue';
import AMSPagination, { PaginationModel } from '@/components/AMSPagination.vue';

@Component({
  components: {
    'ams-product-category-selector': AMSProductCategorySelector,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-pagination': AMSPagination
  }
})
export default class ImportProduct extends Vue {
  paging: PaginationModel = {
    descending: false,
    page: 0,
    rowsPerPage: 10, // -1 for All",
    totalItems: 0,
    pageSizes: [10, 15, 20, 30],
    sortBy: ''
  };
  /**错误数据 */
  showItems: Array<any> = [];

  headers: object[] = [{ text: '行数', align: 'left', value: 'key', sortable: false }, { text: '错误原因', align: 'left', value: 'value', sortable: true }];
  /**选中商品分类 */
  categoryId: string = '';
  /**上传进度 */
  progress: number = 0;
  showLoading: boolean = false;
  /**是否是验证数据 */
  isValidate: boolean = true;
  /**选择的excel文件 */
  file: any = null;
  /**错误数据 */
  items: Array<any> = [];

  invalidedRows: number = 0;
  templateRows: number = 0;
  validatedRows: number = 0;

  /**是否显示第三步 */
  showThirdStep: boolean = false;
  breadItems = [
    {
      text: '商品管理',
      disabled: false,
      href: '/productManage'
    },
    {
      text: '商品列表',
      disabled: false,
      href: '/productManage'
    },
    {
      text: '导入商品',
      disabled: true
    }
  ];
  get total() {
    return `共处理${this.templateRows}条数据，${this.validatedRows}条数据正确，${this.invalidedRows}条数据有误`;
  }

  get tip() {
    return this.isValidate ? '正在验证数据' : '正在上传数据';
  }

  /**商品分类验证规则 */
  get categoryRules() {
    if (this.categoryId == undefined || this.categoryId == '') {
      const rule = (v: any) => {
        return '请选择商品分类';
      };
      return [rule];
    } else {
      return [];
    }
  }

  /**点击了下载模板 */
  onDownClick() {}

  /**点击了上传文件 */
  onUploadClick() {
    // ../productManage/AMS商品导入模板.xlsx
    if ((this.$refs.fileForm as any).validate()) {
      let input = document.getElementById('uploadButton');
      if (input != null) {
        input.click();
      }
    } else {
    }
  }

  /**选择excel并校验正确性 */
  onSelectExcel(value: any) {
    this.isValidate = true;

    const size = value.target.files[0].size;
    if (size) {
      if (size >= 10 * 1024 * 1024) {
        AppStore.ShowError(`文件不能超过${10}M`);
        return;
      }
    } else {
      AppStore.ShowError(`文件不能超过${10}M`);
      return;
    }

    const _this = this;

    this.file = value.target.files[0];

    if (!this.file) {
      AppStore.ShowError('文件错误');
      return;
    }

    /**判断文件类型 */
    const types = '.xls,.xlsx'.split(',');
    const name: string = this.file.name;
    const type = name.substring(name.lastIndexOf('.'));
    console.log(type);
    if (types.indexOf(type) == -1) {
      AppStore.ShowError(`请选择正确格式的文件`);
      return;
    }

    var formData = new FormData();
    formData.append('file', this.file);

    let config = {
      //添加请求头
      headers: { 'Content-Type': 'multipart/form-data' },
      //添加上传进度监听事件
      onUploadProgress: function(e: any) {
        //var completeProgress = (((e.loaded / e.total) * 100) | 0) + '%';
        _this.progress = (e.loaded / e.total) * 100;
      }
    };

    let url = '/api/Product/import/validate';
    this.showLoading = true;
    Axios.post(url, formData, config)
      .then((response: any) => {
        _this.invalidedRows = response.invalidedRows;
        _this.templateRows = response.templateRows;
        _this.validatedRows = response.validatedRows;
        _this.items = response.invalidedMessages;
        _this.paging.page = 0;
        _this.paging.totalItems = _this.items.length;
        _this.showItems = _this.getItemsByPage();
        _this.showThirdStep = true;
        _this.showLoading = false;
        value.target.value = '';
      })
      .catch((error: any) => {
        AppStore.ShowError(error.error && error.error.message ? error.error.message : '上传失败,请重试');
        _this.showThirdStep = false;
        _this.showLoading = false;
        _this.file = null;
        value.target.value = '';
      });
  }

  /**确认上传 */
  onConfirmUpload() {
    if (!(this.$refs.fileForm as any).validate()) {
      return;
    }
    this.isValidate = false;
    const _this = this;

    var formData = new FormData();
    formData.append('file', this.file);
    let config = {
      //添加请求头
      headers: { 'Content-Type': 'multipart/form-data' },
      //添加上传进度监听事件
      onUploadProgress: function(e: any) {
        _this.progress = (e.loaded / e.total) * 100;
      }
    };
    let url = `/api/Product/import?productCatoryId=${this.categoryId}`;
    // formData.append('productCatoryId', this.categoryId);
    this.showLoading = true;
    Axios.post(url, formData, config)
      .then((response: any) => {
        AppStore.ShowSuccess(`成功导入${response}条数据`);
        this.file = null;
        _this.showThirdStep = false;
        _this.showLoading = false;
        _this.$router.back();
      })
      .catch((error: any) => {
        if (error.response.data) {
          if (error.response.data.error) {
            AppStore.ShowError(error.response.data.error.message);
          } else {
            AppStore.ShowError(error.response.data.result.title);
          }
        }
        _this.showThirdStep = false;
        _this.showLoading = false;
      });
  }

  /**点击了上一步 */
  onPreviousStep() {
    this.showThirdStep = false;
  }

  /**点击确认导入 */
  onSubmitClick() {
    if (this.file && this.categoryId) {
      this.onConfirmUpload();
    }
  }

  getItemsByPage() {
    const page = this.paging.page;
    const pageSize = this.paging.rowsPerPage;
    console.log('getItemsByPage',page * pageSize, (page + 1) * pageSize)
    if (this.items.length > 0) {
      return this.items.slice(page * pageSize, (page + 1) * pageSize);
    } else {
      return [];
    }
  }

  onPageChange(page: number) {
    console.log('onPageChange',page)
    this.paging.page = page;
    this.showItems = this.getItemsByPage();
  }

  onPageSizeChange(size: number) {
    this.paging.rowsPerPage = size;
    this.paging.page = 0;
    this.showItems = this.getItemsByPage();
  }
}
